import { React, useState, useContext,useEffect } from 'react';
import UserContext from '../../components/User_Context.js';
import * as api from "../../api/apiConnector.js";
import { useTranslation } from 'react-i18next';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as menu from "../../assets/menus/menu.js";

import { ChangePasswordScreenLabels } from '../_label/user_groups/change_password_screen_labels.js';

function ChangePasswordScreen() {
    const { t } = useTranslation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const MySwal = withReactContent(Swal);
    const { currentUser } = useContext(UserContext);

    // Initialize i18n labels from centralized file
    const i18n = menu.getI18n();
    i18n.addResourceBundle('it', 'labels', ChangePasswordScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', ChangePasswordScreenLabels.en, true, true);



    useEffect(() => {
     
    
          window.$(".deznav").hide();
          window.$(".content-body").removeClass("content-body");
          window.$("#main-wrapper").addClass("menu-toggle");
          window.$(".hamburger").parent().hide();
          window.$(".header-content").hide();
          window.$(".nav-header").hide();
          window.$(".page-titles").hide();
          window.$(".header").hide();
   
      }, []);

    const userPopUpAction = (text) => {
        let progress_div = window.$(`<div class="col-xl-12" data-progress-id="progress-modal" style="z-index: 99999;">
                                        <div class="card dz-card">
                                            <div class="card-header flex-wrap border-0">
                                                <div>
                                                    <h4 class="card-title">${t('update', { ns: 'labels' })}</h4>
                                                </div>											
                                            </div>
                                            <div class="tab-content">
                                                <div class="tab-pane fade active show" role="tabpanel" aria-labelledby="home-tab10">
                                                    <div class="card-body pt-0">
                                                        <h6><span data-progress-file-name="file-name"></span>
                                                            <span class="pull-end">
                                                          ${text}
                                                            </span>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
    
                                        </div>
                                    </div>`);

        let div = window.$(`<div style="position: fixed; right: 10px; bottom: 10px; width: 450px; height: 200px;"></div>`);
        window.$("body").append(div);
        div.append(progress_div);

        setTimeout(() => {
            div.remove();
        }, 3000);
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            MySwal.fire({
                icon: 'error',
                title: t('passwordsDoNotMatch', { ns: 'labels' }),
                text: t('pleaseMakeSureYourPasswordsMatch', { ns: 'labels' }),
            });
            return;
        }

        try {
            var result = await api.sendMessage("security/changePassword", {
                user: currentUser(),
                body: {
                    password: password
                }
            });

            if (result.success) {

                withReactContent(Swal).fire({
                    title: t('passwordChangedSuccessfully', { ns: 'labels' }), 
                                       icon: "success",
                    text: t('passwordChangedSuccessfully', { ns: 'labels' }),
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    confirmButtonText:t('login', { ns: 'labels' }),

                }).then(async (result) => {
                    if (result.isConfirmed) {
                        window.location.href="/logout"
                    }
                });
                
            }else
            {
                if (result.requirements) {
                    const validationPasswordError = [];

                    if (!result.requirements.lowercase) {
                        validationPasswordError.push(t('lowercase', { ns: 'labels' }));
                    }
                    if (!result.requirements.uppercase) {
                        validationPasswordError.push(t('uppercase', { ns: 'labels' }));
                    }
                    if (!result.requirements.numbers) {
                        validationPasswordError.push(t('number', { ns: 'labels' }));
                    }
                    if (!result.requirements.minLength) {
                        validationPasswordError.push(t('minLength', { ns: 'labels' }));
                    }
                    if (!result.requirements.symbols) {
                        validationPasswordError.push(t('symbols', { ns: 'labels' }));
                    }
                    if (!result.requirements.notUsedRecently) {
                        validationPasswordError.push(t('notUsedRecently', { ns: 'labels' }));
                    }


                    if (validationPasswordError.length > 0) {
                        
                        withReactContent(Swal).fire({
                            title: t('error', { ns: 'labels' }),     
                                           icon: "info",
                            text: t(validationPasswordError.join(', ')),
                            showConfirmButton: true,
                            allowOutsideClick: false        
                        })

                    }
                } else {
                    userPopUpAction(t('userSaveError', { ns: 'labels' }));
                }

            }


        } catch (error) {


            
            MySwal.fire({
                icon: 'error',
                title: t('error', { ns: 'labels' }),
                text: t('anErrorOccurredWhileChangingThePassword', { ns: 'labels' }),
            });
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <h3 className="card-title text-center">{t('changePassword', { ns: 'labels' })}</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">{t('newPassword', { ns: 'labels' })}</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">{t('confirmNewPassword', { ns: 'labels' })}</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary w-100">
                                    {t('submit', { ns: 'labels' })}
                                </button>
                            </form>
                            
                            {/* Password Requirements Section */}
                            <div className="mt-4">
                                <h6 className="text-muted mb-3">{t('passwordRequirements', { ns: 'labels' })}</h6>
                                <ul className="list-unstyled small text-muted">
                                    <li className="mb-1">• {t('lowercase', { ns: 'labels' })}</li>
                                    <li className="mb-1">• {t('uppercase', { ns: 'labels' })}</li>
                                    <li className="mb-1">• {t('number', { ns: 'labels' })}</li>
                                    <li className="mb-1">• {t('minLength', { ns: 'labels' })}</li>
                                    <li className="mb-1">• {t('symbols', { ns: 'labels' })}</li>
                                    <li className="mb-1">• {t('notUsedRecently', { ns: 'labels' })}</li>
                                </ul>
                            </div>
                            
                            <br></br>
                            <button type="submit" className="btn btn-primary w-100"
                            onClick={()=>{
                                window.location.href='/'
                               }}
                            >
                                
                                    {t('home', { ns: 'labels' })}
                                </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { ChangePasswordScreen };
